
import React, { useEffect, useRef, useState } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import { useAuth } from '../providers/AuthContext'
import { LoadingPage } from '../components/PageLoading'

export const ChangePasswordPage = ({ instanceData }) => {

  // const defaultLogoURL = '/public/Purview_Logo_Horizontal_Main.png'
  const defaultLogoURL = '/spa/public/purview-logo.png'

  const title = instanceData?.title || 'Purview Image - Change Password'

  const { isCheckingAuth } = useAuth()
  useEffect(() => {
    document.title = title
  }, [title])

  if (isCheckingAuth) {
    return <><LoadingPage /></>
  }


  return <>
    <HeaderComponent />
    <div>
      <label for="password">Password</label>
      <input type="password"></input>
    </div>
  </>
}